import React from 'react';
import Layout from '../components/Layout';
import AnalyticsDashboard from '../components/AnalyticsDashboard';

function AnalyticsPage({ user, onLogout, darkMode, onToggleDarkMode }) {
  return (
    <Layout 
      user={user} 
      onLogout={onLogout} 
      darkMode={darkMode}
      onToggleDarkMode={onToggleDarkMode}
      pageTitle="Analytics"
      pageSubtitle="View your business statistics and trends"
    >
      <AnalyticsDashboard />
    </Layout>
  );
}

export default AnalyticsPage;

